import Workflow from './base';

import { DomuiError, DynamicData, RecordList } from '@domui-domain/type';

class Individual extends Workflow {
  constructor() {
    super('individualwf');
  }

  async getDominoIndividual(dominoId: string) {
    this.setAction('getIndividual');
    this.setData({
      id: dominoId,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getDominoIndividualByNfid(nfId: string) {
    this.setAction('getIndividualByNFId');
    this.setData({
      value: nfId,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getDominoIndividualEmail(email: string) {
    this.setAction('getIndividualEmail');
    this.setData({
      email,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async searchDominoIndividuByOnlineId(onlineId: string) {
    this.setAction('searchIndividuByOnlineId');
    this.setData({
      onlineId,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getDominoIndividuByOtherId(type: string, value: string) {
    this.setAction('getIndividualOtherId');
    this.setData({
      type,
      value,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getPreferredLanguage(profileId: string) {
    this.setAction('getPreferredLanguage');
    this.setData({
      profileId,
    });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getIndividualPrograms(id: string) {
    this.setAction('getIndividualPrograms');
    this.setData({ id });
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getProgramList() {
    this.setAction('getProgramList');
    this.setData({});
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getContactInfo(dominoId: string) {
    this.setAction('getContactInfo');
    this.setData({
      dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateContactInfo(dominoId: string, data: DynamicData) {
    this.setAction('updateContactInfo');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getProfileInfo(dominoId: string) {
    this.setAction('getProfileInfo');
    this.setData({
      dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateProfileInfo(dominoId: string, data: DynamicData) {
    this.setAction('updateProfileInfo');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateOtherInfo(dominoId: string, data: DynamicData) {
    this.setAction('updateOtherInfo');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getProfessionalExperience(dominoId: string) {
    this.setAction('getProfessionalExperience');
    this.setData({
      dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateProfessionalExperience(
    dominoId: string,
    sharingPermissionId: string,
    data: DynamicData
  ) {
    this.setAction('updateProfessionalExperience');
    this.setData({
      dominoId,
      sharingPermissionId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateEditBackground(data: DynamicData) {
    this.setAction('updateEditBackground');
    this.setData({
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getAreasofExpertise(dominoId: string) {
    this.setAction('getAreasOfExpertise');
    this.setData({
      dominoId,
    });

    const res = await this.getCall();
    return res?.data?.wfRes || res?.data || undefined;
  }

  async updateAreasOfExpertise(
    dominoId: string,
    sharingPermissionId: string,
    data: DynamicData
  ) {
    this.setAction('updateAreasOfExpertise');
    this.setData({
      dominoId,
      sharingPermissionId,
      putData: data,
    });

    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async UpdateProgramsSharingPermissions(data: DynamicData) {
    this.setAction('updateProgramsSharingPermissions');
    this.setData({
      putData: data,
    });

    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async createProgram(
    individualId: string,
    programId: string,
    fields: RecordList
  ) {
    this.setAction('createProgram');
    this.setData({
      individualId,
      programId,
      fields,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateProgram(
    individualId: string,
    programId: string,
    individualProgramId: string,
    fields: RecordList
  ) {
    this.setAction('updateProgram');
    this.setData({
      individualId,
      programId,
      individualProgramId,
      fields,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async deleteProgram(individualProgramId: string) {
    this.setAction('deleteProgram');
    this.setData({ individualProgramId });
    try {
      const res = await this.deleteCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchPossibleRoles(dominoId: string, orgId: string) {
    this.setAction('fetchPossibleRoles');
    this.setData({
      id: dominoId,
      organizationPk: orgId,
    });

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateIndividual(domId: string, data: DynamicData) {
    this.setAction('updateIndividual');
    this.setData({
      id: domId,
      putData: data,
    });

    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async createIndividual(data: DynamicData) {
    this.setAction('createIndividual');
    this.setData({
      postData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateProfilePhoto(dominoId: string, requestBody: DynamicData) {
    this.setAction('updateProfilePhoto');
    this.setData({
      dominoId,
      putData: requestBody,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async deleteProfilePhoto(dominoId: string) {
    this.setAction('deleteProfilePhoto');
    this.setData({ dominoId });
    try {
      const res = await this.deleteCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async setPreferredLanguage(dominoId: string, data: DynamicData) {
    this.setAction('setPreferredLanguage');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async basicLoggingInformation(dominoId: string, data: DynamicData) {
    this.setAction('basicLoggingInformation');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getIndividualRotaryResume(dominoId: string) {
    this.setAction('getIndividualRotaryResume');
    this.setData({
      dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateProfilePhotoSharingPermission(
    dominoId: string,
    sharingPermissionId: string
  ) {
    this.setAction('updateProfilePhotoSharingPermission');
    this.setData({
      id: dominoId,
      sharingPermissionId,
    });

    try {
      const res = await this.putCall();
      return res?.data?.wfRes ?? res?.data ?? undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateIndividualResumeSharingPermission(
    dominoId: string,
    sharingPermissionId: string
  ) {
    this.setAction('updateIndividualResumeSharingPermission');
    this.setData({
      id: dominoId,
      sharingPermissionId,
    });

    try {
      const res = await this.putCall();
      return res?.data?.wfRes ?? res?.data ?? undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateIndividualEmail(dominoId: string, data: DynamicData) {
    this.setAction('updateIndividualEmail');
    this.setData({
      dominoId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getOnlineId(dominoId: string) {
    this.setAction('getOnlineId');
    this.setData({
      idType: 'DominoId',
      value: dominoId,
    });
    try {
      const res = await this.getCall();
      if (res?.status === 404) {
        return dominoId;
      }
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }
}

export default Individual;
